import handleSelectorTemplate from './handleSelector.html';

const handleSelector = () => ({
    template: handleSelectorTemplate,
    scope: {
        moreInfo: '=',
        options: '=',
        iconTitle: '=',
        multiSelect: '=',
        selectedOptions: '=',
        defaultSelectedIdFieldName: '=',
        closeBoxCallback: '&?',
        openModalCallback: '&?',
        changeStep: '&?',
        type: '<',
    },
    controller: 'HandleSelectorCtrl',
    controllerAs: 'handleSelector',
    bindToController: true
});

export default handleSelector;